import React from 'react';
import { getSelectedOption } from './commonRingUtils';
import { getV1FinishItems } from './finishItems';
import { getOutsideFeatureItems } from './outsideFeatureItems';
import { getSecondaryOutsideFeatureItems } from './secondaryOutsideFeatureItems';
import { getShapeItems } from './shapeItems';
import { getEngravingItems } from './engravingItems';
import { IPageData } from './Pages';
import { ITab, ITabs } from '../types/customizer';
import SwatchFilter from '../components/SwatchFilter';
import SizeFilter from '../components/SizeFilter';
import Summary from '../components/Summary';
import BoxFilter from '../components/BoxFilter';
import { getCategorizedOptions } from './basic';

export const getV1PageData = (props: IPageData) => {
  const { product: productData, subpath, storeData, isBuildFromScratch } = props;
  const product = { ...productData };
  product.categories = getCategorizedOptions('band', storeData);
  const items: ITabs = [
    {
      title: 'Category',
      helzberg_key: 'category',
      eventKey: 'category',
      component: BoxFilter,
      // Band is unconditional; with only it left there is nothing to switch to.
      isEnabled: product.categories?.length > 1,
      isSelected: isBuildFromScratch,
      content: {
        hasSwatch: true,
        fieldType: 'category',
        options: product.categories,
        selectedOption: getSelectedOption(product.categories)
      }
    },
    {
      title: 'Material',
      label: 'Material',
      helzberg_key: 'material',
      eventKey: 'material',
      component: SwatchFilter,
      isEnabled: product.ring_material?.length > 0,
      isSelected: !isBuildFromScratch,
      content: {
        hasSwatch: true,
        fieldType: 'ring_materials',
        options: product.ring_material,
        selectedOption: getSelectedOption(product.ring_material)
      }
    },
    {
      title: 'Shape',
      helzberg_key: 'shape',
      eventKey: 'shape',
      items: getShapeItems(product),
      tabStyle: 'box'
    },
    ...(product.weight?.length > 0
      ? [
          {
            title: 'Weight',
            label: 'Weight',
            helzberg_key: 'weight',
            eventKey: 'weight',
            component: SwatchFilter,
            isEnabled: product.weight?.length > 0,
            content: {
              hasSwatch: true,
              fieldType: 'weight',
              options: product.weight,
              selectedOption: getSelectedOption(product.weight)
            }
          }
        ]
      : []),
    {
      title: 'Finish',
      helzberg_key: 'finish',
      eventKey: 'finish',
      items: getV1FinishItems(product),
      tabStyle: 'box'
    },
    {
      title: 'Outside Detail 1',
      helzberg_key: 'outside_feature',
      eventKey: 'outsideFeature_1',
      ...getOutsideFeatureItems(product),
      tabStyle: 'box'
    },
    {
      title: 'Outside Detail 2',
      helzberg_key: 'secondary_outside_feature',
      eventKey: 'outsideFeature_2',
      ...getSecondaryOutsideFeatureItems(product),
      tabStyle: 'box'
    },
    {
      title: 'Inside Feature',
      helzberg_key: 'inside_feature',
      label: 'Inside Sleeve',
      eventKey: 'insideFeature',
      component: SwatchFilter,
      isEnabled: product.sleeve?.length > 0,
      content: {
        hasSwatch: true,
        fieldType: 'sleeve',
        options: product.sleeve,
        selectedOption: getSelectedOption(product.sleeve)
      }
    },
    {
      title: 'Engraving',
      helzberg_key: 'engraving',
      eventKey: 'engraving',
      tabStyle: 'box',
      ...getEngravingItems(product, product.engraving_new)
    },
    {
      title: 'Size',
      helzberg_key: 'size',
      label: 'Ring Size',
      eventKey: 'ringSize',
      component: SizeFilter,
      isEnabled: product.size?.length > 0,
      content: {
        hasSwatch: false,
        fieldType: 'size',
        options: product.size || [],
        selectedOption: getSelectedOption(product.size)
      }
    },
    {
      title: 'Order Info',
      helzberg_key: 'summary',
      eventKey: 'summary',
      component: Summary,
      isEnabled: subpath !== 'customize'
    }
  ];
  const filtered = items.filter((tab: ITab) => tab.isEnabled || tab.items?.length);
  return filtered;
};
